import { Routes } from '@angular/router';

import { TabsPage } from '../pages/tabs/tabs.page';

export const tabRoutes: Routes = [
  {
    path: 'tabs',
    component: TabsPage,
    children: [
      {
        path: 'home',
        loadComponent: () => import('#pages/home/home.page').then((m) => m.HomePage),
      },
      {
        path: 'memories',
        loadComponent: () => import('#pages/memories/memories.page').then((m) => m.MemoriesPage),
      },
      {
        path: 'lyfe-vault',
        loadComponent: () =>
          import('#pages/lyfe-vault/lyfe-vault.page').then((m) => m.LyfeVaultPage),
      },
      {
        path: 'celebrations',
        loadComponent: () =>
          import('#pages/celebration/celebration.page').then((m) => m.CelebrationPage),
      },
      {
        path: 'profile',
        loadComponent: () => import('#pages/profile/profile.page').then((m) => m.ProfilePage),
      },
      {
        path: '',
        redirectTo: '/tabs/home',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full',
  },
];
